<template lang="pug">
  div(style='width: 100%;')
    div(style='padding: 0 32px; width: 100%;')
      v-row(no-gutters style='justify-content: space-between;')
        v-col(cols='12')
          .titleLabel.colorDark(style='margin-top: 30px; margin-bottom: 12px;')
            | {{$t('childNodes.nodesInThisFolder')}}
      v-row(v-show='nodeData.children.length' no-gutters)
        v-col(cols='3')
          b {{$t('childNodes.nodeName')}}
        v-col(cols='6')
          b {{$t('childNodes.ifTheWizardRecognizes')}}
        v-col(cols='2')
          b {{$t('childNodes.sons')}}
        v-col(cols='1')
      v-divider
    div(v-for='(node, i) in nodeData.children' :key='i' style='width: 100%; padding-bottom: 12px;')
      v-row(no-gutters style='padding: 12px 32px 0 32px; width: 100%; margin-bottom: 12px;')
        v-col(cols='3' style='padding-right: 8px;')
          v-icon(v-if='node.data.type == "folder"' color='#9c27b0' style='margin-right: 8px;') mdi-folder-text
          b {{ node.data.title }}
        v-col(cols='6' style='padding-right: 8px;')
          span {{ node.data.conditions }}
        v-col(cols='2')
          b {{ node.children.length || "Nenhum" }}
        v-col(cols='1')
          v-btn(icon small @click='$emit("scrollNode", node.data.dialog_node)')
            v-icon(color='#0000ff') mdi-link-variant
            md-tooltip(md-direction="bottom") {{$t('childNodes.goToDialogNode')}}
      v-row(no-gutters style="padding: 0 32px;")
        v-divider
</template>

<script>
export default {
  props: {
    nodeData: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>
.titleLabel {
  width: 100%;
  font-size: 20px;
  line-height: 30px;
}
.colorDark {
  color: #393939;
}
.md-tooltip {
  height: 22px !important;
  padding: 8px !important;
  position: absolute !important;
  z-index: 9999 !important;
  pointer-events: none !important;
  border-radius: 2px !important;
  border-top-left-radius: 2px !important;
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
  transition: 0.15s cubic-bezier(0, 0, 0.2, 1) !important;
  transition-property: opacity, transform !important;
  will-change: opacity, transform, top, left !important;
  font-size: 10px !important;
  line-height: 22px !important;
  text-transform: none !important;
  white-space: nowrap !important;
  min-width: none !important;
  width: 170px !important;
  max-width: 1000px !important;
  height: auto !important;
  line-height: 20px !important;
  text-align: center !important;
  border-radius: 3px !important;
  background-color: rgba(97, 97, 97, 0.9) !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  white-space: normal !important;
  box-shadow: none !important;
}
.md-tooltip:after {
  opacity: 0;
}
</style>
